import React from "react";
import { Dimmer, Loader } from "semantic-ui-react";

function FullPageSpinner() {
  return (
    <Dimmer active page style={{ backgroundColor: "rgba(05, 53, 69, 1)" }}>
      <Loader size="big" aria-label="loading" content="Loading..." />
    </Dimmer>
  );
}

export default FullPageSpinner;
